import { kebabCase } from 'lodash';
import {
  MetricBreakdownContainer,
  MetricBreakdownHeaderContainer,
  MetricBreakdownHeaderTitle,
  MetricBreakdownHeaderValue,
  MetricBreakdownRowWithTwoUnequalColumns,
  MetricList,
  MetricRow,
  SecondaryTabularNumberFont,
  TabularNumberFont,
} from 'modules/campaignAnalytics/components/Styled';
import { Locale } from 'modules/domains';
import { MetricDefinitionPopOver } from 'modules/productAnalytics';
import { formatNumberGivenValueType, metricSentenceCase } from 'modules/productAnalytics/utils';
import { NUMBER, PERCENTAGE } from 'ui/card/constants';
import { FlexSpacer } from 'ui/flexSpacer';
import { QuickRepliesListContainer, RightAlignedMetric } from './Styled';
import { QuickReplyStats } from './types';

export type ListContentProps = {
  locale?: Locale;
  totalReplies: number;
  quickReplyStats: QuickReplyStats[];
};

const tooltip = 'Total number of WhatsApp quick reply buttons clicked by users per locale.';

export const ListContent = ({ locale, totalReplies, quickReplyStats }: ListContentProps) => {
  const name = locale
    ? `Total ${locale.languageName.toLowerCase()} quick replies`
    : 'Total quick replies';
  return (
    <MetricBreakdownContainer>
      <MetricBreakdownHeaderContainer>
        <MetricBreakdownRowWithTwoUnequalColumns>
          <div>
            <MetricBreakdownHeaderTitle data-test={`metric-title-${kebabCase(name)}`}>
              <MetricDefinitionPopOver definition={tooltip}>
                <span>{name}</span>
              </MetricDefinitionPopOver>
            </MetricBreakdownHeaderTitle>
            <MetricBreakdownHeaderValue data-test={`metric-value-${kebabCase(name)}`}>
              {formatNumberGivenValueType(NUMBER, totalReplies) || 'N/A'}
            </MetricBreakdownHeaderValue>
          </div>
        </MetricBreakdownRowWithTwoUnequalColumns>
      </MetricBreakdownHeaderContainer>
      <QuickRepliesListContainer useHorizontalCardPadding data-test={`quick-replies-list`}>
        {quickReplyStats.map((reply) => (
          <MetricList key={reply.name} data-test={`quick-replies-list-${kebabCase(reply.name)}`}>
            <MetricRow>
              <span data-test={`metric-title-${kebabCase(reply.name)}`}>
                {metricSentenceCase(reply.name)}
              </span>
              <FlexSpacer gap="half" justifyContent="flex-end">
                <RightAlignedMetric>
                  <SecondaryTabularNumberFont
                    data-test={`metric-percentage-${kebabCase(reply.name)}`}
                  >
                    {formatNumberGivenValueType(PERCENTAGE, reply.percentage) || 'N/A'}
                  </SecondaryTabularNumberFont>
                </RightAlignedMetric>
                <RightAlignedMetric>
                  <TabularNumberFont data-test={`metric-value-${kebabCase(reply.name)}`}>
                    {formatNumberGivenValueType(NUMBER, reply.value) || 'N/A'}
                  </TabularNumberFont>
                </RightAlignedMetric>
              </FlexSpacer>
            </MetricRow>
          </MetricList>
        ))}
      </QuickRepliesListContainer>
    </MetricBreakdownContainer>
  );
};
